// extracted by mini-css-extract-plugin
export default {"slider":"SlideToggle_slider__fhWEI"};